"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _RecipientBadge = _interopRequireDefault(require("./RecipientBadge"));

var _RecipientInput = _interopRequireDefault(require("./RecipientInput"));

var _utils = require("../../utils");

function RecipientItem(_ref, ref) {
  var contacts = _ref.contacts,
      recipient = _ref.recipient,
      _onChangeRecipient = _ref.onChangeRecipient,
      onSelectRecipient = _ref.onSelectRecipient,
      onBackspace = _ref.onBackspace,
      containerRef = _ref.containerRef,
      getRecipientAvatar = _ref.getRecipientAvatar;

  var _useState = (0, _react.useState)(!recipient),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      editable = _useState2[0],
      setEditable = _useState2[1];

  var inputRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (editable && inputRef.current) {
      inputRef.current.select();
    }
  }, [editable]);

  if (editable) {
    return /*#__PURE__*/_react["default"].createElement(_RecipientInput["default"], {
      className: "flex-grow-0 flex-shrink-0",
      getRecipientAvatar: getRecipientAvatar,
      ref: inputRef,
      containerRef: containerRef,
      contacts: contacts,
      defaultRecipient: recipient,
      onChangeRecipient: function onChangeRecipient() {
        _onChangeRecipient.apply(void 0, arguments);

        setEditable(false);
      },
      onBackspace: onBackspace
    });
  } else {
    return /*#__PURE__*/_react["default"].createElement(_RecipientBadge["default"], (0, _extends2["default"])({}, recipient, {
      ref: ref,
      onDoubleClick: function onDoubleClick() {
        return setEditable(true);
      },
      onClick: function onClick() {
        return !(0, _utils.isEmail)(recipient.email) && setEditable(true);
      },
      onClose: function onClose() {
        return _onChangeRecipient(null);
      },
      onSelect: onSelectRecipient
    }));
  }
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(RecipientItem);

exports["default"] = _default;
//# sourceMappingURL=RecipientItem.js.map